import React from "react"
import { useControl } from "../../../controlContext"
import { NAR } from "../../../../../shared/Data/typeDirs"

export function ExportNarratives({idx}){
  let {[idx]:{ [NAR]: {content}, _id: blockId}} = useControl()
    // const { settings: { readOnly: allReadOnly, lockMap } } = useControlHeaderContext()
    // const readOnly = useMemo(() => (allReadOnly ? true : lockMap && lockMap[blockId]), [lockMap, allReadOnly, blockId])
  return (
    <div dangerouslySetInnerHTML={{__html:content}}/>
  ) 
}